import { render, staticRenderFns } from "./seleClass.vue?vue&type=template&id=124a9a1a&scoped=true&"
import script from "./seleClass.vue?vue&type=script&lang=js&"
export * from "./seleClass.vue?vue&type=script&lang=js&"
import style0 from "./seleClass.vue?vue&type=style&index=0&id=124a9a1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124a9a1a",
  null
  
)

export default component.exports